import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useSecondOrderCallback, useViewport } from '@chilecompra/react-kit'
import { Card, Popover, PopoverMenuItem, Typography } from '@chilecompra/react-kit/components'
import { formatTypeCurrency } from '../../modules/utils/formatTypeCurrency'
import { Anchor, AnchorIcon, AnchorText, Divider, GridContainer, GridItem } from './QuoteBidSeller.styles'
/**
 * The Quote Bid Amount's component.
 */
const QuoteBidAmount = props => {
  const {
    amount,
    taxation,
    netWorth,
    percentageTaxation,
    taxationOptions,
    typeCurrency,
    maxAmountsUTMs,
    maximumAmountFormater,
    disabled
  } = props
  const { size } = useViewport()
  const [taxesOpen, setTaxesOpen] = useState(false)
  const [taxesValue, setTaxesValue] = useState(1)
  const maxAmounts = `Recuerda que el monto total cotizado no debe superar las ${maxAmountsUTMs} UTM. equivalente en pesos a $${maximumAmountFormater}`
  const taxesName = useMemo(
    () => taxationOptions.find(option => option.value === taxesValue)?.name || '',
    [taxationOptions, taxesValue]
  )
  const createHandleTaxesChange = useSecondOrderCallback(
    (_, updatedValue) => {
      setTaxesValue(updatedValue)
      setTaxesOpen(false)
      percentageTaxation(updatedValue)
    },
    [percentageTaxation]
  )
  const handleCloseTaxes = useCallback(() => setTaxesOpen(false), [])
  const handleOpenTaxes = useCallback(() => setTaxesOpen(true), [])

  return (
    <>
      <Card enableBorder color="primary">
        <GridContainer padding="0 0 44px" spacing={2}>
          <GridItem align={size.isDownToTiny ? 'left' : 'right'} sm={7} xs={12}>
            <Typography color="black2" fontSize="14px" lineHeight="18px" variant="body2">
              Valor neto
            </Typography>
          </GridItem>
          <GridItem align={size.isDownToTiny ? 'left' : 'right'} sm={5} xs={12}>
            <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
              {!disabled ? formatTypeCurrency(typeCurrency, netWorth, true) : '-'}
            </Typography>
          </GridItem>
          <GridItem align={size.isDownToTiny ? 'left' : 'right'} sm={7} xs={12}>
            <Popover
              disabled="true"
              anchor={
                <Anchor style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
                  <AnchorText>{taxesName}</AnchorText>
                  <AnchorIcon open={taxesOpen} />
                </Anchor>
              }
              open={taxesOpen}
              onClose={handleCloseTaxes}
              onOpen={handleOpenTaxes}
            >
              {taxationOptions.map(option => (
                <PopoverMenuItem enableClose key={option.value} onClick={createHandleTaxesChange(option.value)}>
                  {option.name}
                </PopoverMenuItem>
              ))}
            </Popover>
          </GridItem>
          <GridItem align={size.isDownToTiny ? 'left' : 'right'} sm={5} xs={12}>
            <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
              {!disabled ? formatTypeCurrency(typeCurrency, taxation, true) : '-'}
            </Typography>
          </GridItem>
        </GridContainer>
        <Divider />
        <GridContainer padding="12px 0 0">
          <GridItem align={size.isDownToTiny ? 'left' : 'right'}>
            <Typography color="black3" fontSize="16px" lineHeight="20px" variant="body1">
              Monto total
            </Typography>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem align={size.isDownToTiny ? 'left' : 'right'}>
            <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="body1">
              {!disabled ? formatTypeCurrency(typeCurrency, amount, true) : '-'}
            </Typography>
          </GridItem>
        </GridContainer>
      </Card>
      <GridContainer name="test" padding="4px 0 0">
        <GridItem xs={12}>
          <Card color="default">
            <GridContainer margin="5px 0 0">
              <GridItem xs={12}>
                <Typography color="black3" fontSize="14px" lineHeight="18px" variant="body2">
                  {maxAmounts}
                </Typography>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  )
}

QuoteBidAmount.propTypes = {
  amount: PropTypes.number.isRequired,
  netWorth: PropTypes.number.isRequired,
  percentageTaxation: PropTypes.func.isRequired,
  taxation: PropTypes.number.isRequired,
  taxationOptions: PropTypes.array.isRequired,
  typeCurrency: PropTypes.string.isRequired,
  maxAmountsUTMs: PropTypes.number,
  maximumAmountFormater: PropTypes.string,
  disabled: PropTypes.bool
}

export default QuoteBidAmount
